export default __webpack_public_path__ + "static/media/homebuying.9f6b3955.jpg";